import { DownloadLinkButton } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { formatCurrency } from "@/lib/forms/utils"

import type {
  Application,
  DebtScheduleStateEnum,
} from "@boundless/bl-api-client/lender/models"

const debtAnswerLabels: Record<DebtScheduleStateEnum, string> = {
  "no-debt": "Declared no debt",
  submitted: "Debt schedule provided",
  skipped: "Skipped",
  pending: "Not answered",
}

export function FundingNeedsCard({
  application,
}: {
  application: Application
}) {
  const { capitalAmount, useOfFunds } = application.fundingNeeds
  return (
    <Card>
      <CardHeader>
        <CardTitle>Boundless Application</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-row items-center justify-between">
        <DownloadLinkButton url={application.appDocDownloadUrl}>
          Download
        </DownloadLinkButton>
        <p className="font-medium">
          ASK:{" "}
          <span className="font-light">
            {formatCurrency(capitalAmount.toString())}
          </span>
        </p>
        <p className="font-medium">
          USE OF FUNDS: <span className="font-light">{useOfFunds}</span>
        </p>
        <p className="font-medium">
          DEBT:{" "}
          <span className="font-light">
            {debtAnswerLabels[application.debtScheduleState]}
          </span>
        </p>
      </CardContent>
    </Card>
  )
}
